import { Component, Input, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { LanguageService } from '../../services/other/language.service';
import { AvatarModule } from 'primeng/avatar';

@Component({
  selector: 'supplierDB-registration-header',
  standalone: true,
  imports: [ButtonModule, MenuModule, AvatarModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit {
  @Input() headerText: string = '';

  public languages: MenuItem[] | undefined;

  public flagImgSource!: string;

  constructor(private _languageService: LanguageService) {
    this._languageService.languageLocale$
      .asObservable()
      .subscribe((language) => {
        this._updateFlagImgSource(language);
      });
  }

  ngOnInit(): void {
    this.languages = [
      {
        label: 'English',
        command: () => this.changeLanguage('en'),
        routerLink: '/assets/img/flags/english_lang.png',
      },
      {
        label: 'Deutsch',
        command: () => this.changeLanguage('de'),
        routerLink: '/assets/img/flags/german_lang.png',
      },
      {
        label: 'Español',
        command: () => this.changeLanguage('es'),
        routerLink: '/assets/img/flags/spanish_lang.png',
      },
      {
        label: 'Português',
        command: () => this.changeLanguage('pt'),
        routerLink: '/assets/img/flags/portuguese_lang.png',
      },
    ];
  }

  /**
   * Updates the flag image source based on the selected language.
   * @param {string} language - The language code to determine the flag image.
   * @returns {void}
   */
  private _updateFlagImgSource(language: string): void {
    switch (language) {
      case 'de':
        this.flagImgSource = '/assets/img/flags/german_lang.png';
        break;
      case 'es':
        this.flagImgSource = '/assets/img/flags/spanish_lang.png';
        break;
      case 'pt':
        this.flagImgSource = '/assets/img/flags/portuguese_lang.png';
        break;
      default:
        this.flagImgSource = '/assets/img/flags/english_lang.png';
        break;
    }
  }

  /**
   * Updates the current language of the application.
   * @param {string} language - The new language code to be set. It should be one of the following: 'en', 'de', 'es', 'pt'.
   * @returns {void} - This function does not return any value.
   */
  public changeLanguage(language: string): void {
    this._languageService.setLanguage(language);
  }
}
